import React from 'react';

function Loader() {
  return (
    <div className="flex flex-col items-center justify-center h-full min-h-[200px] p-8">
      <div className="flex flex-col items-center space-y-4">
        {/* Simple modern spinner */}
        <div className="animate-spin rounded-full h-12 w-12 border-3 border-gray-200 border-t-indigo-600"></div>
        
        {/* Simple loading text */}
        <div className="text-center">
          <p className="text-base font-medium text-gray-700">Loading...</p>
          <p className="text-sm text-gray-500 mt-1">Please wait</p>
        </div>
      </div>
    </div>
  );
}

export default Loader;